<template>
	<div
		class="summary__contents"
		:class="`is-sectionTitle-${sectionTitleStyle}`"
	>
		<div class="summary__section">
			<p class="summary__sectionTitle">{{ $t("Deltas") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemValue" v-html="deltaCfgSummaryContent"></div>
				</div>
			</div>
		</div>

		<div class="summary__section">
			<p class="summary__sectionTitle">{{ $t("Carga") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Geral") }}
					</div>
					<div class="summary__itemValue" v-html="generalLoadSummaryContent" />
				</div>
				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Excecional") }}
					</div>
					<div
						class="summary__itemValue"
						v-html="exceptionalLoadSummaryContent"
					/>
				</div>

				<div class="summary__item" v-if="values.snow.snowAccumulation.use">
					<div class="summary__itemLabel">
						{{ $t("Acumulação de Neve") }}
					</div>
					<div
						class="summary__itemValue"
						v-html="snowAccumulationSummaryContent"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import emitLifecycleEvents from "@/mixins/emitLifecycleEvents";

import { uniq } from "@/utils";

import BBtn from "@/components/base/BBtn.vue";
import BIcon from "@/components/base/BIcon/index.vue";

export default {
	mixins: [emitLifecycleEvents],
	components: {
		BBtn,
		BIcon,
	},
	props: {
		values: {
			type: Object,
			required: true,
		},
		sectionTitleStyle: {
			type: String,
			default: "block",
		},
	},
	computed: {
		...mapState("simulator", ["simulationOptions"]),
		...mapGetters("simulator", [
			"getOption",
			"spanDescriptions",
			"getMainSpanDescriptions",
			"consoleSpanDescriptions",
		]),
		deltaCfgSummaryContent() {
			const { deltas } = this.values.snow;

			return deltas
				.map((delta, idx) => {
					return `<p>Ψ${idx} - ${delta}</p>`;
				})
				.join("");
		},
		generalLoadSummaryContent() {
			return this.getLoadSummaryContent(this.values.snow.general);
		},
		exceptionalLoadSummaryContent() {
			return this.getLoadSummaryContent(this.values.snow.exceptional);
		},
		snowAccumulationSummaryContent() {
			const { s, l } = this.values.snow.snowAccumulation;

			let sStr;
			let lStr;

			if (uniq(s).length == 1) {
				sStr = `<p>S1,2,3: ${s[0]} kN/m2</p>`;
			} else {
				sStr = s
					.map((val, idx) => {
						return `<p>S${idx + 1}: ${val} kN/m2</p>`;
					})
					.join("");
			}

			if (uniq(l).length == 1) {
				lStr = `<p>L1,2,3: ${l[0]} kN/m2</p>`;
			} else {
				lStr = l
					.map((val, idx) => {
						return `<p>L${idx + 1}: ${val} kN/m2</p>`;
					})
					.join("");
			}

			return sStr + lStr;
		},
	},
	methods: {
		getLoadSummaryContent(load) {
			const { main, console, cfgMode } = load;
			let items;

			if (!cfgMode.isSpanBySpan) {
				items = [`${main[0]} kN/m2`];
			} else {
				items = [
					...console.map((val, idx) => {
						const label = this.consoleSpanDescriptions[idx].label;
						return `${this.$t(label)}: ${val} kN/m2`;
					}),
					...main.map((val, idx) => {
						const label = this.getMainSpanDescriptions(this.values.spans)[idx]
							.label;
						return `${this.$t(label)}: ${val} kN/m2`;
					}),
				];
			}
			return items.map((item) => `<p>${item}</p>`).join("");
		},
	},
};
</script>

<style lang="scss"></style>
